import { useEffect } from "react";
import { Link } from "react-router-dom";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const ReportsPage = () => {
  useEffect(() => {
    document.title = "Отчеты";
  }, []); 

  return (
    <section className="settings">
      <div className="container">
        <ButtonBack shortBtn={true} userUrl="/admin"/>

        <h1 className="settings__text">Отчеты</h1>

        <div className="admin__menu">
          <Link
            to="/admin/reports/mas-region-pharmacy"
            className="admin__menu__item"
          >
            Масы + Регионы + Аптеки
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ReportsPage;
